var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "sm-button",
        { attrs: { loading: _vm.loading }, on: { click: _vm.initEnrollment } },
        [_vm._v("\n    Enroll passkey\n  ")]
      ),
      _vm._v(" "),
      _vm.success
        ? _c("p", { staticClass: "message message--success" }, [
            _vm._v("\n    Passkey enrolled ✅\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("p", { staticClass: "message message--error" }, [
            _vm._v("\n    " + _vm._s(_vm.error) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }